var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-loader"},[_c('lottie-animation',_vm._g(_vm._b({ref:"loading",attrs:{"animationData":require('@/assets/loader/black-loader.json'),"loop":true,"autoPlay":true,"speed":1}},'lottie-animation',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }